export interface Status {
  id              : number;
  messageProperty : string;
}

export enum StatusId {
  OFFEN = 20,
  AUTOMATISCH_BEWILLIGT = 30,
  BEWILLIGT = 40,
  STORNO_ANFRAGE = 50,
  STORNIERT = 90
}

export namespace StatusId {
  export function isBewilligt(id: StatusId) {
    return id === StatusId.BEWILLIGT || id === StatusId.AUTOMATISCH_BEWILLIGT;
  }
}
